import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import { Accessor } from "./Accessor";
import { TopHitsMetric } from "../query";
export var NoFiltersHitCountAccessor =
/*#__PURE__*/
function (_Accessor) {
  _inherits(NoFiltersHitCountAccessor, _Accessor);

  function NoFiltersHitCountAccessor() {
    var _this;

    _classCallCheck(this, NoFiltersHitCountAccessor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NoFiltersHitCountAccessor).apply(this, arguments));
    _this.aggsKey = "no_filters_top_hits";
    return _this;
  }

  _createClass(NoFiltersHitCountAccessor, [{
    key: "getCount",
    value: function getCount() {
      return this.getAggregations([this.aggsKey, "hits", "total"], 0);
    }
  }, {
    key: "buildOwnQuery",
    value: function buildOwnQuery(query) {
      if (query.getQueryString() && query.getSelectedFilters().length > 0) {
        return query.setAggs(TopHitsMetric(this.aggsKey, {
          size: 1,
          _source: false
        }));
      }

      return query;
    }
  }]);

  return NoFiltersHitCountAccessor;
}(Accessor);